import { convertDate, displayCurrentHour } from "../../utils/helper";
import "./QueueItem.scss";
import close from "../../assets/icons/close.svg";
import edit from "../../assets/icons/edit.svg";
import Modal from "../Modal/Modal";
import EditModal from "../EditModal/EditModal";
import { useState } from "react";

const QueueItem = ({
  item,
  priority,
  deleteHandler,
  editHandler,
  editErrors,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  const { subreddit, title, datetime, id } = item;

  console.log("datetime", datetime);
  console.log("convertDate(datetime)", convertDate(datetime));
  return (
    <article className="queue-item">
      <div className="queue-item__container">
        <h3 className="queue-item__header">{`${priority}. ${title}`}</h3>{" "}
        <p className="queue-item__text">
          To be published on{" "}
          <a
            href={`https://reddit.com/r/${subreddit}`}
            target="_blank"
            className="queue-item__link"
            rel="noopener noreferrer"
          >
            r/{subreddit}
          </a>
        </p>
        <div className="queue-item__container-bottom">
          <p className="queue-item__text">
            Scheduled for {convertDate(datetime)} at{" "}
            {displayCurrentHour(false, new Date(datetime).getHours())} BST
          </p>
          <div className="queue-item__buttons-container">
            <img
              src={edit}
              alt="Edit icon"
              className="queue-item__img-edit"
              onClick={() => setOpenEditModal(true)}
            />
            <img
              src={close}
              alt="Close icon"
              className="queue-item__img"
              onClick={() => {
                setOpenModal(true);
              }}
            />
          </div>
        </div>
      </div>
      <Modal
        openModal={openModal}
        setOpenModal={setOpenModal}
        onClickHandler={() => deleteHandler(id)}
        id={id}
      />
      <EditModal
        openEditModal={openEditModal}
        setOpenEditModal={setOpenEditModal}
        editHandler={editHandler}
        item={item}
        editErrors={editErrors}
      />
    </article>
  );
};

export default QueueItem;
